import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=1549003a"
import script from "./Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports